import { Scissors, Sparkles, Palette, Droplets, Wind, Hand, Eye, User, Smile } from "lucide-react";

// Mapeia palavras-chave do serviço para um ícone (lucide)
// Ordem importa — mais específico primeiro
const SERVICE_ICON_RULES = [
  { match: /mecha|luzes|balayage|ombr[eé]|reflex/i, Icon: Sparkles, color: "#F59E0B", bg: "#FEF3C7", label: "Luzes/Mechas" },
  { match: /tonali|colora|matiz|henn[eê]|nuance|tinta/i, Icon: Palette, color: "#7C3AED", bg: "#EDE9FE", label: "Coloração" },
  { match: /hidrat|botox|selagem|cauter|reconstru/i, Icon: Droplets, color: "#0EA5E9", bg: "#E0F2FE", label: "Hidratação" },
  { match: /escova|progress|aliso|liso/i, Icon: Wind, color: "#DB2777", bg: "#FCE7F3", label: "Escova" },
  { match: /manicure|pedicure|esmalt|unha/i, Icon: Hand, color: "#BE185D", bg: "#FCE7F3", label: "Manicure" },
  { match: /sobrancelha|design|micropigment/i, Icon: Eye, color: "#1F2937", bg: "#E5E7EB", label: "Sobrancelha" },
  { match: /facial|limpeza|pele|peeling/i, Icon: Smile, color: "#10B981", bg: "#D1FAE5", label: "Estética facial" },
  { match: /corte|barba/i, Icon: Scissors, color: "#0F766E", bg: "#CCFBF1", label: "Corte" },
];

export function getServiceHint(serviceNames = []) {
  for (const rule of SERVICE_ICON_RULES) {
    if (serviceNames.some((s) => rule.match.test(s || ""))) return rule;
  }
  return { Icon: User, color: "#6B7280", bg: "#F3F4F6", label: "Cliente" };
}

export default function ClientAvatar({ client, services = [], size = 40, onClick }) {
  const hint = getServiceHint(services);
  const Icon = hint.Icon;
  const px = `${size}px`;
  const innerPx = `${Math.round(size * 0.5)}px`;
  const ringStyle = onClick ? { cursor: "pointer" } : {};

  if (client?.avatar_url) {
    return (
      <button
        type="button"
        onClick={onClick}
        title={hint.label}
        className="relative inline-block shrink-0 rounded-full overflow-hidden ring-2 ring-white shadow-sm hover:ring-amber-300 transition"
        style={{ width: px, height: px, ...ringStyle }}
        data-testid={`client-avatar-${client.client_id}`}
      >
        <img
          src={client.avatar_url}
          alt={client.name}
          className="w-full h-full object-cover"
          loading="lazy"
          decoding="async"
          width={size}
          height={size}
        />
        <span
          className="absolute -bottom-0 -right-0 rounded-full p-0.5 ring-1 ring-white"
          style={{ background: hint.bg }}
          title={hint.label}
        >
          <Icon className="h-2.5 w-2.5" strokeWidth={2} style={{ color: hint.color }} />
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      title={hint.label}
      className="inline-flex items-center justify-center shrink-0 rounded-full ring-2 ring-white shadow-sm hover:ring-amber-300 transition"
      style={{ width: px, height: px, background: hint.bg, ...ringStyle }}
      data-testid={`client-avatar-${client.client_id}`}
    >
      <Icon style={{ color: hint.color, width: innerPx, height: innerPx }} strokeWidth={1.6} />
    </button>
  );
}
